import React, { Component } from 'react';
import images from './images';
import './styles.css';

class GameHeader extends Component {
	render() {

		const { children } = this.props

		return (
			<div className='game-header'>
				<img style={{
					width: '163px'
				}} src={images['bocconi']} alt={images['bocconi']} />
				{children}
			</div>
		);
	}
}


export default GameHeader;
